import Main from '../components/Main';
import PageLayout from '../components/pageLayout';

function MainPage() {

    return (
        <PageLayout children={<Main />} />
    );
}

export default MainPage;
